import PropTypes from 'prop-types';
import { eventSourceTypes } from './Constants/events';

const requiredEventProps = {
    /**
     * event ID
     */
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    /**
     * event hash
     */
    hash: PropTypes.string.isRequired,
    /**
     * type of event
     */
    eventType: PropTypes.string.isRequired,
    /**
     * title of the event
     */
    title: PropTypes.string.isRequired,
    /**
     * start time of the event, could be string or date object
     */
    startTime: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        .isRequired,
    /**
     * end time of the event, could be string or date object
     */
    endTime: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        .isRequired,
    /**
     * image of the event
     */
    image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }).isRequired,
    /**
     * event label, could be string or null
     */
    label: PropTypes.string,
    /**
     * event source type
     */
    sourceType: PropTypes.oneOf(eventSourceTypes).isRequired,
    /**
     * url for single event page or null
     */
    viewUrl: PropTypes.string,
    /**
     * api end point for registration or null
     */
    registrationUrl: PropTypes.string,
    /**
     * whether it is promoted, could be either 0 or 1
     */
    isPromoted: PropTypes.number.isRequired,
    /**
     * whether it is featured, could be either 0 or 1
     */
    isFeatured: PropTypes.number.isRequired,
    /**
     * whether current user is registered for the event
     */
    userRegistered: PropTypes.bool.isRequired,
    /**
     * url for the location where the event is hosting
     */
    joinUrl: PropTypes.string,
    /**
     * whether registration is deactived or not, it derived from "userRegistered && !joinUrl"
     */
    registrationDeactivated: PropTypes.bool,
    /**
     * whether the event requires authentication to be view
     */
    authenticationRequired: PropTypes.number,
    /**
     * whether event registration has a deadline
     */
    registrationDeadline: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    /**
     * sponsor of the event
     */
    sponsors: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            description: PropTypes.string,
            companyId: PropTypes.number,
            companyUrl: PropTypes.string,
        })
    ),
};

const notRequiredEventProps = {
    /**
     * meta data for SEO purposes
     */
    googleSeo: PropTypes.string,
    /**
     * banner image for single event page
     */
    bannerImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    /**
     * video for single event page
     */
    video: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    /**
     * event description
     */
    description: PropTypes.string,
    /**
     * whether countdown timer is shown
     */
    showCountdownTimer: PropTypes.number,
    /**
     * event speakers
     */
    event: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            location: PropTypes.string,
            shortBio: PropTypes.string,
            bio: PropTypes.string,
        })
    ),
};

export const eventPropTypesShape = PropTypes.shape({
    /**
     * props that are required for every event components
     */
    ...requiredEventProps,
    /**
     * props that are not required for every event components, required for single event page
     */
    ...notRequiredEventProps,
});
